import { SnackBarService } from "src/app/services/common/snackBar.service";
import { Component, OnInit, Input } from "@angular/core";

import { IGroup } from "src/app/interfaces/group";
import { SoundEnum } from "src/app/enums/sound.enum";
import { TranslateService } from "@ngstack/translate";
import { IGroupAction } from "src/app/interfaces/group-action";
import { GroupRouteActionService } from "src/app/services/http/business/group-route-action/group-route-action.service";

@Component({
  selector: "app-group-route-action",
  templateUrl: "./group-route-action.component.html",
  styleUrls: ["./group-route-action.component.css"]
})
export class GroupRouteActionComponent implements OnInit {
  @Input() selectedAction: number[];
  @Input() groupSelected: IGroup;
  expand: boolean;
  panelOpenState = false;
  routes: any;
  selectAll: boolean;
  actionsId: number[] = [];

  constructor(
    private groupRouteAction: GroupRouteActionService,
    private snackBarService: SnackBarService,
    public translate: TranslateService
  ) { }

  ngOnInit() {
    this.loadList();
  }

  loadList() {
    this.groupRouteAction.ListMenuForManagerUserAccess().subscribe(res => {
     
      this.routes = res;
      console.log(this.selectedAction);
      
      for (let i of res) {
        i["selectAll"]=null;
        for (let j of i.pagRouteActionList) {
          //j["isSelectItem"] = false;
          this.actionsId.push(j.id);
        }
      }
    });
  }

  operationSelectAll(item:any,eventChecked:boolean){ 
   
      //this.selectedAction = new Array();
      if (this.selectedAction == null) {
        this.selectedAction = new Array();
      }
        item.pagRouteActionList.forEach(element => {
          element["isSelectItem"] = eventChecked;
          if (eventChecked) {
            let temp = this.selectedAction.find(id =>id == element.id);
              if (!temp) {
                //this.selectedAction.splice(this.selectedAction.indexOf(temp),1);
                this.selectedAction.push(element.id);
              }
          }
          else {
           // this.selectedAction.splice(this.selectedAction.indexOf(item), 1);
            let index = this.selectedAction.indexOf(element.id);
            if (index > -1) {
             this.selectedAction.splice(index, 1);
           }
          }
          this.check(element);
        });
  }
  checkAllBox(routeItem : any) {
      this.operationSelectAll(routeItem,routeItem.selectAll);
  }

  check(action:any) {
    if (this.selectedAction) {
    //  for (let id of this.selectedAction) {
        //if (id == action.id) {
         // action["isSelectItem"] = true;
         // return true;
        //} 
     // }
     return this.selectedAction.some(id => id == action.id );
    }
  }

  checkExpanded(pagRouteActionList: any[]) {
    var aids = pagRouteActionList.map(q => q.id);
    if (this.selectedAction){
      //aids["isSelectItem"] = true;
      return this.selectedAction.some((val) => aids.indexOf(val) !== -1);
    } else
    {
     // aids["isSelectItem"] = false;
      return false;

    }
  }

  checkList(checked:boolean, item:any,selectAll:boolean) {
   
    if (selectAll!=null) {
      selectAll = false;
    }
    if (this.selectedAction == null) {
      this.selectedAction = new Array();
    }
    if (checked) {
      this.selectedAction.push(item.id);
      item["isSelectItem"] = false;
    }
    if (!checked) {
     // this.selectedAction.splice(this.selectedAction.indexOf(item.id), 1);
      // this.selectedAction.splice(item, 1);
      let index = this.selectedAction.indexOf(item.id);
      if (index > -1) {
       this.selectedAction.splice(index, 1);
     }
    }
  }

  submit() {
   
    let grRoute: IGroupAction = {
      GroupId: this.groupSelected.Id,
      ActionList: this.selectedAction
    };
    this.groupRouteAction.saveActionListByGroupId(grRoute).subscribe(() => {
      this.loadList();
      this.snackBarService.OpenSnackBar(
        this.translate.get("success.registration"),
        "ok",
        5000,
        SoundEnum.beep
      );
    });
  }
}
